import { useEffect, useState } from "react";
import CardLayout from "../common/CardLayout";
import InputGeneric from "../common/InputGeneric";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { DateTimePicker } from "../ui/date-time-picker";
import apiProduto from "../../services/apis/apiProduto";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import useToast from "../../hooks/useToast";
import apiLeituraProduto from "../../services/apis/Leituras/apiLeituraProduto";
import apiAmbientes from "../../services/apis/apiAmbientes";

export default function CadastroLeituraProduto({ onSave }) {

    const unidadeId = getCurrentUnidadeId();
    const { sucesso, erro, aviso } = useToast();

    const [ambientesTuneis, setAmbientesTuneis] = useState([]);
    const [form, setForm] = useState({
        dataHora: new Date(),
    });

    const [produtos, setProdutos] = useState([]);

    async function save(e) {
        e.preventDefault();
        
        const { temperatura, tempoRetencao, produtoId, ambienteId, dataHora } = form;

        try {
            await apiLeituraProduto.upsert({
                temperatura: parseFloat(temperatura),
                tempoRetencao: tempoRetencao,
                produtoId: produtoId,
                ambienteId: ambienteId,
                dataHora:dataHora
            });

            sucesso("Leitura salva com sucesso!");
            onSave();
        } catch (error) {
            erro("Erro ao salvar a leitura do produto!");
        } finally {
            setForm({
                dataHora: new Date(),
                temperatura: 0,
                tempoRetencao: 0,
                produtoId: 0,
            })
        }
    }


    useEffect(() => {
        (async () => {
            try {
                const res = await apiProduto.getByUnidadeId(unidadeId);
                setProdutos(res.data);
                const resAmbiente = await apiAmbientes.getAmbientesTuneis(unidadeId);
                setAmbientesTuneis(resAmbiente.data);
            } catch (error) {
                
            }
        })();
    }, [unidadeId]);

    function handleDateDeChange(date) {
        setForm({
            ...form,
            dataHora: date
        })
    }
    
    return (
        <div className="flex justify-center flex-col items-center gap-2 w-full h-full">
            <div className="flex flex-col w-full">
                <CardLayout>
                    <form className=" min-h-[100px] flex gap-5 justify-center items-center flex-wrap"  onSubmit={save}>
                        <div>
                            <label htmlFor="" className="block text-center text-[16px]">Data</label>
                            <DateTimePicker
                                className={"ring-1 ring-accent"}
                                formatString="dd/MM/yyyy"
                                selectedDate={form.dataHora}
                                onDateChange={handleDateDeChange}
                            />
                        </div>
                        <div>
                            <label htmlFor="ambienteId" className="block text-center text-[16px]">Ambiente</label>
                            <Select
                                id="ambienteId"
                                onValueChange={(value) => {setForm({
                                    ...form,
                                    ambienteId: parseInt(value)
                                })}}
                                value={form.ambienteId}
                                required
                            >
                                <SelectTrigger className="w-[200px] ring-accent ring-1">
                                    <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                    {
                                        ambientesTuneis.map((ambiente, i) => (
                                            <SelectItem key={ambiente.id}
                                                value={ambiente.id}
                                            >
                                                {ambiente.nome}
                                            </SelectItem>
                                        ))
                                    }
                                </SelectContent>
                            </Select>
                        </div>
                        <div>
                            <label htmlFor="temperatura" className="block text-center text-[16px]">Temperatura</label>
                            <InputGeneric
                                id="temperatura"
                                name="temperatura"
                                value={form.temperatura}
                                onChange={(e) => setForm({
                                    ...form,
                                    temperatura: e.target.value
                                })}
                                className={"w-[200x] h-[39px] m-0"}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="tempo-retencao" className="block text-center text-[16px]">Tempo Retenção</label>
                            <InputGeneric
                                id="tempo-retencao"
                                name="tempo-retencao"
                                value={form.tempoRetencao}
                                onChange={(e) => setForm({
                                    ...form,
                                    tempoRetencao: parseFloat(e.target.value)
                                })}
                                className={"w-[200x] h-[39px] m-0"}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="produtoId" className="block text-center text-[16px]">Produto</label>
                            <Select
                                id="produtoId"
                                onValueChange={(value) => {setForm({
                                    ...form,
                                    produtoId: parseInt(value)
                                })}}
                                value={form.produtoId}
                                required
                            >
                                <SelectTrigger className="w-[200px] ring-accent ring-1">
                                    <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                    {
                                        produtos.map((produto, i) => (
                                            <SelectItem key={produto.id}
                                                value={produto.id}
                                            >
                                                {produto.nome}
                                            </SelectItem>
                                        ))
                                    }
                                </SelectContent>
                            </Select>
                        </div>
                        <div className="h-full flex items-end justify-center">

                            <Button
                                className="mt-5"
                            >
                                Salvar
                            </Button>
                        </div>
                    </form>
                </CardLayout>

            </div>
        </div>
    )
}